(function () {
    'use strict';

    angular
        .module('app')
        .controller('SeriesExchangeController', SeriesExchangeController);

    SeriesExchangeController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$timeout',
        '$location',
        '$filter',
        'blockUI',
        'CouponsService'
    ];

    function SeriesExchangeController(
        $rootScope,
        $scope,
        $routeParams,
        $timeout,
        $location,
        $filter,
        blockUI,
        CouponsService
    ) {

        $scope.params = {
            batches: {
                page: 1,
                count: 20,
                same_country: true
            }
        }

        $scope.data = {
            summary: {},
            pagerLengths: [10, 20, 50, 100, 200]
        }

        var block_batches_list = blockUI.instances.get('batches_list'),
            filterTimeout;

        $scope.getLocalizedPath = getLocalizedPathFromLang;
        $scope.getLocalizeField = getLocalizeField;
        $scope.getPages = getTotalPaginatedPages;

        initController();

        function initController() {
            _doShow();
        }

        function _doShow() {
            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.use_coupon_exchange) {
                        getCouponsBatches();
                        $rootScope.TARIFF_LIMITATION.use_coupon_exchange = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.use_coupon_exchange = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function getCouponsBatches() {
            block_batches_list.start();

            var params = angular.copy($scope.params.batches);

            CouponsService.BatchesExchange(params, function (success, response) {
                if (success) {
                    $scope.data.couponBatchesList = response.data;
                    $scope.data.summary = response.summary;
                }

                block_batches_list.stop();
            });
        }

        $scope.onFilterChange = function () {
            if (filterTimeout)
                $timeout.cancel(filterTimeout);

            filterTimeout = $timeout(function () {
                $scope.params.batches.page = 1;

                getCouponsBatches();
            }, 1000);
        }

        $scope.onPageChange = function () {
            getCouponsBatches();
        };

        $scope.onCountChange = function (entity, count) {
            $scope.params.batches.page = 1;
            $scope.params.batches.count = count;

            getCouponsBatches();
        }

        $scope.onCouponTake = function (batch) {
            var params = {
                p: true,
                c: batch.code,
                t: batch.public_title,
                d: batch.public_description,
                pb: batch.emission_period_begin,
                pe: batch.emission_period_end
            }

            if (batch.url)
                params.img = batch.url;

            $location.path('/series/create').search(params);
        }
    }
})();
